/**
 * channelListContent.tsx
 */
import Channel from '@shared/classes/channel';
import ChannelList from '../list/channelList/channelList';
import ChannelListContentContainer from '@components/atoms/container/channelListContentContainer';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListInfo from './content/channelListInfo';
import { useContext } from 'react';

/**
 * ChannelListContent component props.
 */
interface Props {
  data: Channel[];
  setChannel: (
    channel: Channel | undefined,
    increment: number | undefined
  ) => void;
}

/**
 * Displays the channel list content including the channel list and the channel list info.
 */
export default function ChannelListContent({ data, setChannel }: Props) {
  const { index, focused } = useContext(ChannelListContext);
  return (
    <ChannelListContentContainer id={'channelListContentContainer'}>
      <ChannelList
        circular={true}
        channelsData={data}
        focused={focused}
        currentIndex={index}
        onChangeState={setChannel}
      />
      <ChannelListInfo />
    </ChannelListContentContainer>
  );
}
